export default __webpack_public_path__ + "static/media/chino.f37412d2.jpeg";